import React from 'react'
import PropTypes from 'prop-types'

import { Button, Container, Input } from '@sainsburys-tech/fable'

import api from '../../utils/api'
import userManager from '../../utils/identity'
import {
  getRememberMe,
  setRememberMe,
  isTokenExpired,
  removeToken,
} from '../../utils/storage'
import LoadingOverlay from '../LoadingOverlay'
import EmailConfirmationModal from '../Email/EmailConfirmationModal'
import Logger from '../../utils/logger'
import redirectUser from '../../utils/routeHelper'
import { deviceTypes } from '../../utils/device'
import '../../sass/components/login.scss'

class LoginForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      validCredentials: true,
      rememberMeChecked: false,
      emailHasBeenVerified: null,
      loading: false,
      isModalOpen: false,
      loadingPage: true,
      isActive: true
    }
  }

  componentWillMount() {
    const {
      setHeader,
      setLoggedInUser,
      setSignOutHeader,
      history,
      loggedOut
    } = this.props

    setHeader()
    setSignOutHeader(false)

    if (loggedOut) {
      this.setState({ loadingPage: false })
      removeToken()
      setRememberMe(false)
      setLoggedInUser(null)
    } else if (!isTokenExpired() || getRememberMe() === 'true') {
      this.getDeviceType()
      redirectUser(history)
    } else {
      this.setState({ loadingPage: false })
      this.getDeviceType()
      setLoggedInUser(null)
    }
  }

  getDeviceType = () => {
    const urlSearchString = window.location.search
    const { setDeviceType, deviceType } = this.props

    const search = new URLSearchParams(urlSearchString)

    if (urlSearchString && !deviceType) {
      if (search.get('devicetype') === 'mobileapp') {
        setDeviceType(deviceTypes.MobileApp)
      }
    } else if (!deviceType) {
      setDeviceType(deviceTypes.MobileWebsite)
    }
  }

  handleUserNameChanges = (e) => {
    if (this.state.isActive === false) {
      this.setState({ isActive: true })
    }
    const nextValue = (e || '').trim()
    this.setState({ username: nextValue })
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e || '' })
  }

  isValidateForm = () => {
    const { username, password, isActive } = this.state
    if (password && username && isActive) {
      return true
    }
    return false
  }

  handleSubmit = () => {
    const { username, password, rememberMeChecked } = this.state
    const { setUserName } = this.props
    this.setState({ loading: true })
    const user = {
      username,
      password,
      RememberMe: rememberMeChecked
    }

    setRememberMe(rememberMeChecked)

    api
      .login(user)
      .then((res) => {
        setUserName(username)
        if (res.status === 400) {
          this.setState({ validCredentials: false, loading: false })
          setRememberMe(false)
          return
        }
        if (res.status === 401) {
          this.setState({
            emailHasBeenVerified: false,
            loading: false,
            isModalOpen: true
          })
          setRememberMe(false)
          return
        }
        if (res.status === 403) {
          this.setState({
            loading: false,
            isActive: false
          })
          setRememberMe(false)
          return
        }

        this.setState({ validCredentials: true, emailHasBeenVerified: true })

        setTimeout(() => {
          userManager.signinRedirect()
            .catch((error) => {
              Logger.logError(error)
              this.setState({ loading: false })
            })
        }, 500)
      })
      .catch((error) => {
        Logger.logError(error)
        this.setState({ loading: false })
      })
  }

  toggleRememberMe = (e) => {
    this.setState({ rememberMeChecked: e.target.checked })
  }

  handleRegisterBtn = () => {
    const { history } = this.props
    history.push('/register')
  }

  handleForgottenPasswordClick = () => {
    const { history } = this.props
    this.setState(
      { username: '', password: '', rememberMeChecked: false },
      history.push('/forgottenpassword')
    )
  }

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      username: '',
      password: '',
      validCredentials: true,
      rememberMeChecked: false
    })
  }

  showModal = () => {
    const { emailHasBeenVerified, isModalOpen } = this.state
    const { history, user } = this.props
    if (!emailHasBeenVerified) {
      return (
        <EmailConfirmationModal
          isModalOpen={isModalOpen}
          history={history}
          errorModal
          email={user.userName}
          closeModal={this.closeModal}
        />
      )
    }
    return null
  }

  render() {
    const {
      username,
      password,
      validCredentials,
      loading,
      rememberMeChecked,
    } = this.state

    return (
      <React.Fragment>
        {this.state.loadingPage && (
          <LoadingOverlay />
        )}
        {!this.state.loadingPage && (
          <Container as="div" className="dsib-login">
            {this.showModal()}
            <h2 className="dsib-login__title">Log in</h2>
            <div className="dsib-login__formWrap">
              <div className="dsib-login__fields">
                <div className="dsib-login__field">
                  <Input
                    label="Username"
                    value={username}
                    onChange={value => this.handleUserNameChanges(value)}
                    inputProps={{
                      id: 'txtUsername',
                      name: 'txtUsername',
                      autoComplete: 'username'
                    }}
                  />
                </div>

                <div className="dsib-login__field">
                  <Input
                    label="Password"
                    type="password"
                    value={password}
                    onChange={value => this.handlePasswordChange(value)}
                    inputProps={{
                      id: 'txtPassword',
                      name: 'txtPassword',
                      autoComplete: 'current-password'
                    }}
                  />
                </div>
              </div>

              <label className="dsib-login__remember">
                <input
                  className="dsib-login__rememberInput"
                  type="checkbox"
                  name="checkRememberMe"
                  checked={rememberMeChecked}
                  onChange={this.toggleRememberMe}
                />
                <span className="dsib-login__rememberLabel">Remember me on this device</span>
              </label>

              <div className="dsib-login__actions">
                <div className="dsib-login__loginButton">
                  <Button
                    id="btnLogin"
                    type="button"
                    onClick={this.handleSubmit}
                    disabled={!this.isValidateForm()}
                    isFullWidth
                    variant="primary"
                  >
                    Log in
                  </Button>
                </div>
              </div>

              {validCredentials === false && (
                <div className="dsib-login__error" role="alert">
                  Invalid Username or Password
                </div>
              )}

              <div className="dsib-login__register">
                <div className="dsib-login__loginButton">
                  <button
                    type="button"
                    className="dsib-login__registerLink"
                    onClick={() => this.handleRegisterBtn()}
                  >
                    Register
                  </button>
                </div>
              </div>

              <div className="dsib-login__forgot">
                <button
                  type="button"
                  className="dsib-login__forgotLink"
                  onClick={() => this.handleForgottenPasswordClick()}
                >
                  Forgotten your password?
                </button>
              </div>
            </div>
            {loading && <LoadingOverlay hasBackground />}
          </Container>
        )}
      </React.Fragment>
    )
  }
}

LoginForm.propTypes = {
  setDeviceType: PropTypes.func.isRequired,
  deviceType: PropTypes.number,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  setUserName: PropTypes.func.isRequired,
  setLoggedInUser: PropTypes.func.isRequired,
  user: PropTypes.shape({
    userName: PropTypes.string.isRequired,
  }).isRequired,
  loggedOut: PropTypes.bool
}

LoginForm.defaultProps = {
  deviceType: null,
  loggedOut: false
}

export default LoginForm
